import HomePage from "../components/guest";

// const appst = () => {
//   return <HomePage />;
// };
export default HomePage;
